import React, { useState } from 'react';
import './Contact.css';
import { Form, Input, Row, Col, Select } from 'antd';
import LOGO from '../../assets/logo2.png';
import { QRCode } from 'antd';

const { TextArea } = Input;

export const Contact = () => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    location: 'Lebanon',
    postcode: '',
    message: '',
  });

  const handleFormChange = (changedValues, allValues) => {
    setFormData(allValues);
  };

  const handleSubmit = () => {
    const { firstName, lastName, email, address, location, postcode, message } = formData;
    const mailtoLink = `mailto:info@atox-lb.com?subject=Contact%20Form&body=Name:%20${firstName}%20${lastName}%0AEmail:%20${email}%0AAddress:%20${address}%0ALocation:%20${location}%0APostcode:%20${postcode}%0AMessage:%20${message}`;
    window.open(mailtoLink, "_self");
  };

  return (
    <div className='contact-page'>
      <header className='height-75'>
        <div className='container h-100  min-vh-100 d-flex flex-column align-items-center justify-content-center text-light'>
          <h1 className='text-center fw-semibold lspacing-10'>GET IN TOUCH</h1>
          <h3 className='text-center w-75 mb-1 lspacing-10'>Your Queries, Our Priority</h3>
        </div>
      </header>

      <div className='container my-5 d-flex justify-content-center'>
        <Form
          form={form}
          id='contact-form'
          layout="vertical"
          onFinish={handleSubmit}
          onValuesChange={handleFormChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[{ required: true, message: 'Please enter your first name' }]}
              >
                <Input placeholder='First name' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={[{ required: true, message: 'Please enter your last name' }]}
              >
                <Input placeholder='Last name' />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter your email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input placeholder='Enter email' />
          </Form.Item>

          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: 'Please enter your address' }]}
          >
            <Input placeholder='Your address' />
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Location"
                name="location"
                initialValue="Lebanon"
              >
                <Select disabled>
                  <Select.Option value="Lebanon">Lebanon</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Postcode"
                name="postcode"
                rules={[{ required: true, message: 'Please enter your postcode' }]}
              >
                <Input placeholder='Postcode' />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Your Message"
            name="message"
            rules={[{ required: true, message: 'Please enter your message' }]}
          >
            <TextArea rows={3} placeholder='Your message' />
          </Form.Item>

          <Form.Item shouldUpdate>
            {() => (
            <button 
              type='submit' 
              disabled={
                form.getFieldsError().some(({ errors }) => errors.length > 0)
              }
              className='btn bg-blue btn-outline-light btn-lg mt-5'>submit
              </button>
            )}
          </Form.Item>
        </Form>
      </div>

      <div className='bg-dark text-light p-5'>
        <div className='container'>
          <h2 className='text-center mb-3'>Our Location</h2>
          <div className='row g-4 justify-content-center'>
            <div className='col-lg-4 d-flex flex-column align-items-center'>
              <QRCode
                size={200}
                color='white'
                errorLevel="H"
                value="https://maps.app.goo.gl/X8snuzRMejk9dKpC9"
                icon={LOGO}
              />
              <h3 className='text-center mt-3'>Beirut</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
